export type DateType = {
  value: number;
  title: string;
}

export const months: DateType[] = [
  { value: 0, title: 'January' },
  { value: 1, title: 'February' },
  { value: 2, title: 'March' },
  { value: 3, title: 'April' },
  { value: 4, title: 'May' },
  { value: 5, title: 'June' },
  { value: 6, title: 'July' },
  { value: 7, title: 'August' },
  { value: 8, title: 'September' },
  { value: 9, title: 'October' },
  { value: 10, title: 'November' },
  { value: 11, title: 'December' },
];

export const yearsRange = (start = (new Date()).getFullYear(), stop = 1960, step = -1): DateType[] =>
  Array.from(
    { length: Math.floor((stop - start) / step) + 1 },
    (_, i) => {
      const year = start + i * step;
      return { value: year, title: year.toString() };
    }
  );


export function getRelativeTime(dateString?: string): string {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return '';
  }

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = diffDays / 365;

  if (diffSeconds < 60) {
    return 'just now';
  } else if (diffMinutes < 60) {
    return diffMinutes === 1 ? '1 minute ago' : `${diffMinutes} minutes ago`;
  } else if (diffHours < 24) {
    return diffHours === 1 ? '1 hour ago' : `${diffHours} hours ago`;
  } else if (diffDays < 7) {
    return diffDays === 1 ? '1 day ago' : `${diffDays} days ago`;
  } else if (diffWeeks < 4) {
    return diffWeeks === 1 ? '1 week ago' : `${diffWeeks} weeks ago`;
  } else if (diffMonths < 12) {
    return diffMonths === 1 ? '1 month ago' : `${diffMonths} months ago`;
  } else if (diffYears < 2) {
    return '1 year ago';
  } else {
    // For years with decimal (like 1.5 years)
    const years = Math.floor(diffYears);
    const remainingMonths = Math.floor((diffYears - years) * 12);

    if (remainingMonths >= 6) {
      return `${years}.5 years ago`;
    } else {
      return `${years} years ago`;
    }
  }
}